import {ExpressionPath} from '@packages/systems/wfdl';

export const START_AT_PATH: ExpressionPath = [{in: 'Record', at: 'startAt'}];
export const SHOW_ALL_RELATED_VIDEO_PATH: ExpressionPath = [
  {in: 'Record', at: 'showAllRelatedVideos'},
];
export const CONTROLS_PATH: ExpressionPath = [{in: 'Record', at: 'controls'}];
export const AUTOPLAY_PATH: ExpressionPath = [{in: 'Record', at: 'autoplay'}];
export const MUTED_PATH: ExpressionPath = [{in: 'Record', at: 'muted'}];
export const PRIVACY_MODE_PATH: ExpressionPath = [
  {in: 'Record', at: 'privacyMode'},
];

export const EMBED_PATH: ExpressionPath = [{in: 'Record', at: 'embed'}];
const OPTIONS_PATH: ExpressionPath = [{in: 'Record', at: 'options'}];
export const EMBED_META_PATH: ExpressionPath = [
  ...EMBED_PATH,
  {in: 'Record', at: 'meta'},
];
export const EMBED_META_URL_PATH: ExpressionPath = [
  ...EMBED_META_PATH,
  {in: 'Record', at: 'url'},
];
export const EMBED_META_TITLE_PATH: ExpressionPath = [
  ...EMBED_META_PATH,
  {in: 'Record', at: 'title'},
];
export const EMBED_META_VIDEO_ID_PATH: ExpressionPath = [
  ...EMBED_META_PATH,
  {in: 'Record', at: 'videoId'},
];
export const EMBED_META_ASPECT_RATIO_PATH: ExpressionPath = [
  ...EMBED_META_PATH,
  {in: 'Record', at: 'aspectRatio'},
];

const OPTIONS_START_AT_PATH: ExpressionPath = [
  ...EMBED_PATH,
  ...OPTIONS_PATH,
  ...START_AT_PATH,
];
const OPTIONS_SHOW_ALL_RELATED_VIDEOS_PATH: ExpressionPath = [
  ...EMBED_PATH,
  ...OPTIONS_PATH,
  ...SHOW_ALL_RELATED_VIDEO_PATH,
];
const OPTIONS_CONTROLS_PATH: ExpressionPath = [
  ...EMBED_PATH,
  ...OPTIONS_PATH,
  ...CONTROLS_PATH,
];
const OPTIONS_AUTOPLAY_PATH: ExpressionPath = [
  ...EMBED_PATH,
  ...OPTIONS_PATH,
  ...AUTOPLAY_PATH,
];
const OPTIONS_MUTED_PATH: ExpressionPath = [
  ...EMBED_PATH,
  ...OPTIONS_PATH,
  ...MUTED_PATH,
];

export const paramToPathsMap = {
  youtube_rel: OPTIONS_SHOW_ALL_RELATED_VIDEOS_PATH,
  youtube_controls: OPTIONS_CONTROLS_PATH,
  youtube_autoplay: OPTIONS_AUTOPLAY_PATH,
  youtube_mute: OPTIONS_MUTED_PATH,
  youtube_start: OPTIONS_START_AT_PATH,
  youtube_fs: null,
  youtube_modestbranding: null,
};

export const AUTOPLAY = 'AUTOPLAY';
export const PRIVACY_MODE = 'PRIVACY_MODE';
export const TOOLTIP_TEXT = {
  [AUTOPLAY]:
    'Autoplay is limited by certain browsers, and usually requires Mute to be enabled as well.',
  [PRIVACY_MODE]:
    'Privacy Enhanced Mode allows you to embed videos without using cookies.',
};
